import { metaAccount } from '@/router/meta-config'
const permissionKey = 'BLOGPOST'

export default [
  {
    path: '/blog-posts',
    name: 'page-blog-posts',
    component: () => import('@/pages/blogPosts'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/blog-post/new',
    name: 'page-blog-post-new',
    component: () => import('@/pages/blogPost'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/blog-post/:id',
    name: 'page-blog-post',
    component: () => import('@/pages/blogPost'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
